export default __webpack_public_path__ + "static/media/sidebar-bg.ea9380f7.svg";